<!-- 异常类型Column -->
<template>
    <div class='uk-text-center' :class='exTypeTagCls(row.exCatalog)'>
        {{ exType[row.exCatalog] && $t(alarmReason[row.exCatalog].title) }}
    </div>
</template>

<script>
import {alarmReason} from '@/utils/convert'
export default {
    props: ['row'],
    data() {
        return {
            alarmReason
        }
    },
    mounted () {
    console.log('this.$store.state.exType')

    console.log(this.$store.state.exType)
  },
    computed: {
        exType () {
            return this.$store.state.exType
        },
        exTypeTagCls () {
            return (catalog) => {
                switch (catalog) {
                case 0:
                    return 'ex-connection-tag'
                case 1:
                    return 'ex-data-tag'
                case 2:
                    return 'ex-power-tag'
                }
            }
        }
    },
}
</script>
